module.exports = __webpack_public_path__ + "static/media/charles03.8e43d2b8.jpg";